import { mapActions, mapState } from 'vuex';
import showShareAlert from '@f/share';
import { isHllApp, parseURL, parseQuery } from '@/utils';

export default {
  computed: {
    ...mapState('app', {
      actData: function(state) {
        return state[this.moduleName].actData;
      }
    })
  },
  methods: {
    ...mapActions('app', {
      getShareCode: function(dispatch, ...props) {
        return dispatch(`${this.moduleName}/getShareCode`, ...props);
      }
    }),
    getShareConfig() {
      if (!this.actData) {
        return {};
      }
      return {
        shareUrl: this.actData.shareUrl,
        shareTitle: this.actData.shareTitle,
        shareContent: this.actData.shareContent
      };
    },
    resolveUrl(url, shareCode) {
      const urlObj = parseURL(url);
      let searchStr = `fromShare=1&invitation_code=${shareCode}`;
      const currentSearch = parseQuery();
      if (currentSearch.ref) {
        searchStr += `&ref=${currentSearch.ref}`;
      }
      if (urlObj.search) {
        urlObj.search += `&${searchStr}`;
      } else {
        urlObj.search += `?${searchStr}`;
      }
      return urlObj.toString();
    },
    /**
     * 调起分享 options.shareMode = normal|invite
     * @param {Object} options
     */
    async launchShare({ url, ...otherOptions }) {
      if (!isHllApp()) {
        return Promise.reject({ msg: '请前往货拉拉企业App进行邀请~' });
      }
      let urlWithShareCode = null;
      try {
        const shareCode = await this.getShareCode();
        urlWithShareCode = this.resolveUrl(url, shareCode);
      } catch (error) {
        throw error;
      }
      console.debug(urlWithShareCode);
      const shareConfig = this.getShareConfig();
      const config = {
        title: shareConfig.shareTitle,
        desc: shareConfig.shareContent,
        img: shareConfig.shareUrl,
        miniIco: shareConfig.shareUrl,
        link: urlWithShareCode,
        ...otherOptions
      };
      return new Promise(resolve => {
        showShareAlert({
          config,
          isShowErr: false,
          isHideQrcode: true,
          callback: target => {
            resolve(target);
          }
        });
      });
    }
  }
};
